import { P2GImage } from '@parcel2go/core-ui';

interface props {
  src: string;
  alt: string;
  style?: any;
  onError: (src: string, key?: string) => void;
}

const RouterImage = (props: props) => {
  return (
    <P2GImage
      alt={props.alt}
      src={
        window.location.href.indexOf('localhost') > -1 ? `https:\\apps.backoffice.parcel2go.com${props.src}` : props.src
      }
      style={props.style}
      onError={props.onError}
    />
  );
};
export default RouterImage;
